import BaseObject from '../../../base/base_object';
import IRestrictionValueBase from './restriction_value_base_interface';

export default class NoRestrictionValue extends BaseObject implements IRestrictionValueBase {
    static CLASS = 'NoRestrictionValue';

    public isGameAllowedInTheGrid(): boolean {
        return true;
    }

    public isGameAllowedToPlayReal(): boolean {
        return true;
    }

    public showUserMessage(): void {
    }


    public isExpired(): boolean {
        return true;
    }

    public isActiveRestrictionForOpenApplication(): boolean {
        return false;
    }
}
